import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import useDeviceType from "../../Utils/useDeviceType";

export function JPush() {
    const { isWebview } = useDeviceType();
    const history = useHistory();

    useEffect(() => {
        if (!isWebview) return;

        function listener(msg: any) {
            try {
                if (typeof msg?.data !== "string") return;
                const data = JSON.parse(msg?.data);
                if (typeof data !== "object") return;
                if (data.type !== "PUSH") return;
                if (!data.data?.target) return;
                history.push(data.data?.target);
            } catch (e) {}
        }

        window.addEventListener("message", listener);

        return () => {
            window.removeEventListener("message", listener);
        };
    }, []);

    return null;
}
